import * as React from 'react';
import cx from 'classnames';

import Preloader from '../Preloader';
import PreviewContent from './components/PreviewContent';

import {
    getMapWithTyles,
    setupMap,
    setupMarkers,
    setupImageTyles,
    setupCoordinates,
    setupDirection,
    setupPlace,
    getCurrentPosition,
} from '../../services/map';
import { getParamsFromUrl, setParamsToUrl } from '../../helpers';

import "../Preloader/preloader.scss";
import './map.scss';

const prahaCoordinates = {
    lat: 50.1003,
    lng: 14.2555,
    zoom: 12,
};

const contentString = `<h1>HTML Ipsum Presents</h1><p><strong>Pellentesque habitant morbi tristique</strong> senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis. Ut felis.</p>`;

const Map = () => {
    const [initialized, setInitialized] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [hasSobs, setSobs] = React.useState(false);
    const [markers, setMarkers] = React.useState([]);
    let map = null;
    google.maps.event.addDomListener(
        window,
        'load',
        () => {
            setTimeout(() => {
                setInitialized(true);
                setLoading(false);
            }, 2000);
        },
    );
    if (!map && initialized) {
        map = setupMap(prahaCoordinates);
        setupImageTyles(map);
        map.addListener('center_changed', () => {
            setupImageTyles(map);
        });
        map.addListener('zoom_changed', () => {
            setupImageTyles(map);
        });
    }
    React.useEffect(() => {
        setupMarkers(map, markers);
    }, [markers]);

    const handleOnUrlData = () => {
        const result = getParamsFromUrl();
        if (!result) {
            setParamsToUrl();
        } else {
            getMapWithTyles(result.coordinates, result.markers)();
        }
    };

    const handleAddSob = () => {
        setMarkers([ { lat: 50.108, lng: 14.27, contentString }, { lat: 50.108, lng: 14.29, contentString } ]);
        setSobs(true);
        new google.maps.Marker({
            position: { lat: 50.108, lng: 14.27 },
            map,
            title: '',
        });
        map.setCenter({ lat: 50.108, lng: 14.27 });
    };

    const handleSetupRoute = () => {
        const start = new google.maps.LatLng(50.108, 14.27);
        const end = new google.maps.LatLng(50.108, 14.29);
        setupDirection(map, start, end);
    };

    const handleOnCurrentPosition = () => {
        getCurrentPosition(map);
    };

    const handleFindByPlace = (placeId: string) => {
        setupPlace(placeId, map);
    }

    return (
        <>
            <Preloader loading={loading} />
            <div
                className={cx('map-wrap', loading && 'loading')}
                id={'map-wrap'}
            />
            {(!loading) && (
                <PreviewContent
                    handleOnCurrentPosition={handleOnCurrentPosition}
                    handleFindByPlace={handleFindByPlace}
                    handleAddSob={handleAddSob}
                    hasSobs={hasSobs}
                    handleSetupRoute={handleSetupRoute}
                    handleOnUrlData={handleOnUrlData}
                />
            )}
        </>
    );
}

export default Map;
